export const toDateFormat = (date: string) => {
  return date?.split("-").reverse()?.join(".");
};
